import styles from "./Brand.module.css";

const CHEVRONS = [
  { d: "M16 25 L32 11 L48 25", rest: 1, liftClass: styles.liftTop },
  { d: "M16 40 L32 26 L48 40", rest: 0.6, liftClass: styles.liftMid },
  { d: "M16 55 L32 41 L48 55", rest: 0.3, liftClass: styles.liftBot },
];

function TradeLyftMark({
  size = 64,
  animated = false,
  showTile = true,
  inheritStroke = false,
  className,
  title,
}) {
  const classes = [
    styles.mark,
    inheritStroke ? styles.markInherit : null,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <svg
      className={classes}
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role={title ? "img" : "presentation"}
      aria-hidden={title ? undefined : true}
      aria-label={title}
      style={{
        width: size,
        height: size,
        "--tl-mark-size": `${size}px`,
      }}
    >
      {showTile ? (
        <rect width="64" height="64" rx="16" fill="#5446EB" />
      ) : null}
      {CHEVRONS.map((chevron) => (
        <g
          key={chevron.d}
          className={animated ? `${styles.lift} ${chevron.liftClass}` : undefined}
          opacity={animated ? undefined : chevron.rest}
        >
          <path className={styles.chevron} d={chevron.d} />
        </g>
      ))}
    </svg>
  );
}

export default TradeLyftMark;
